/**
 * @Description 得分卡片（四维时使用）
 */
import { FC } from 'react';
import styles from './index.module.less';

const ScoreCard: FC<any> = ({
  title = '-',
  totalScore = 100,
  lineColor = '#89D4FF', // 进度条颜色
  lineBgColor = '#EEEEEE' // 进度条背景色
  // describe = '-'
}) => {
  return (
    <div className={styles.scoreCard}>
      <div className={styles.titleCon}>
        <span>
          {title }
        </span>
        <div className={styles.lineBg} style={{ backgroundColor: lineBgColor }}>
          <div className={styles.lineVal} style={{ width: `${totalScore}%`, backgroundColor: lineColor }}></div>
        </div>
        <span className={styles.score}>
          {totalScore}
        </span>
      </div>
      {/* <div className={styles.desc}>
        {describe}
      </div> */}
    </div>
  );
};

export default ScoreCard;
